import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import {AppHeaderComponent } from './components/app-header'
import {AppFooterComponent } from './components/app-footer'
import {MatMenuModule, MatButtonModule} from '@angular/material';

@NgModule({
  imports: [
      CommonModule,
      MatMenuModule,
      MatButtonModule
   ],
  declarations: [
       AppHeaderComponent, AppFooterComponent
  ],
  exports: [
      AppHeaderComponent, AppFooterComponent
  ]
})
export class SharedModule {}



// WEBPACK FOOTER //
// /opt/sss_web/sss_web/src/app/shared.module.ts